import { render, staticRenderFns } from "./RemoteWorkingView.vue?vue&type=template&id=210f9a0c&"
import script from "./RemoteWorkingView.vue?vue&type=script&lang=js&"
export * from "./RemoteWorkingView.vue?vue&type=script&lang=js&"
import style0 from "./RemoteWorkingView.vue?vue&type=style&index=0&id=210f9a0c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports